<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dealerUser.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dealerUser.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper class="d-flex ts-justify-between">
        <ts-button outline color="info" @click.prevent="addNew">{{ $t('add_new') }}</ts-button>
        <div class="d-flex">
          <ts-input
            v-model="search"
            :placeholder="$t('dealerUser.search')"
            style="width: 250px;"
            class="inline-block"
          />
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.name }}</td>
          <td>{{ record.user_name }}</td>
          <td>{{ record.user_type.label }}</td>
          <td>{{ record.dealer ? record.dealer.dealer_name : null }}</td>
          <td>
            <span class="badge badge-success" v-if="!record.disable">Yes</span>
            <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center ts-space-x-5">
            <a href="#" class="text-info" @click.prevent="showModal(record)">
              <i class="fa fa-lock"></i>
            </a>
            <a href="#" v-tooltip="$t('edit')" class="text-primary" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <!-- show form create -->
    <a-modal
      v-if="create_form"
      v-model="create_form"
      :title="$t('create')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      @cancel="onClose"
      width="400px"
    >
      <form-create-office @close="onClose" v-if="isOffice" />
      <form-create-super @close="onClose" v-else />
    </a-modal>
    <!-- show form create -->
    <a-modal
      v-if="update_form"
      v-model="update_form"
      :title="$t('update')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      @cancel="onClose"
      width="400px"
    >
      <form-update @close="onClose" />
    </a-modal>
    <a-modal
      v-if="reset_password"
      v-model="reset_password"
      :title="$t('dealerUser.resetPassword')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      @cancel="onClose"
      width="400px"
    >
      <reset-password @close="onClose" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FormCreateOffice from './components/frm_create_office'
import FormCreateSuper from './components/frm_create_super'
import FormUpdate from './components/frm_update'
import ResetPassword from './components/frm_reset_password'

export default {
  name: 'dealerUser',
  components: {
    FormCreateOffice,
    FormCreateSuper,
    FormUpdate,
    ResetPassword
  },
  data() {
    return {
      loading: false,
      create_form: false,
      update_form: false,
      reset_password: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/dealerUser', ['resources', 'pagination']),
    isOffice() {
      return this.$store.state.authUser
        ? this.$store.state.authUser.user_type == 1
        : false
    },
    isSupperDealer() {
      if (this.$store.state.authUser) {
        return this.$store.state.authUser.user_type == 2
      }
      return false
    },
    search: {
      get() {
        return this.$store.state.administrator.dealerUser.search
      },
      set(newValue) {
        this.$store.commit('administrator/dealerUser/SET_SEARCH', newValue)
        this.$store.commit('administrator/dealerUser/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('dealerUser.diplayName') },
        { name: this.$t('dealerUser.userName') },
        { name: this.$t('dealerUser.userType') },
        { name: this.$t('dealerUser.dealerName') },
        { name: this.$t('dealerUser.active') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/dealerUser/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.create_form = true
    },
    onClose() {
      this.create_form = false
      this.update_form = false
      this.reset_password = false
      this.fetchData()
      this.$store.commit('administrator/dealerUser/SET_EDIT_DATA', {})
    },
    edit(record) {
      this.update_form = true
      this.$store.commit('administrator/dealerUser/SET_EDIT_DATA', record)
    },
    showModal(record) {
      this.reset_password = true
      this.$store.commit('administrator/dealerUser/SET_EDIT_DATA', record)
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/dealerUser/RESET_STATE')
    next()
  }
}
</script>
